<script>
	import VerticalDivider from '#lib/VerticalDivider.svelte';
	import Icon from '#lib/Icon.svelte';
  import MainPageContent from "#lib/MainPageContent.svelte";
  import BlockGrid from "#lib/BlockGrid.svelte";
  import ButtonLabel from "#lib/ButtonLabel.svelte";
  import Image from "#lib/Image.svelte";
  import Avatar from "#lib/Avatar.svelte";
  import ScrollIndicator from "#lib/ScrollIndicator.svelte";
  import t from '#lib/i18n.svelte.js';
  import {
    plot_curved_distribution,
    yyyy_mm_dd_from_date,
    localize_utc_date,
    format_date,
  } from '#lib/util.js';
  import { getContext } from 'svelte';
  import { format_price_info, get_formatted_time, format_half_hourly_slot_duration } from '#lib/patch_util.js';
  import SEO from "#lib/SEO.svelte";
  import Alert from "#lib/Alert.svelte";
  import { goto } from '$app/navigation';
  import { page } from '$app/state';
  let { data } = $props();

  let site_settings = getContext('site_settings');

  let booking_overview_for_day_date_formatted = $derived(format_date(new Date(data.booking_overview_for_day.date), 'DMMMY'));
  let today_date = $derived(yyyy_mm_dd_from_date(localize_utc_date(new Date())));
  
  // function get_colors_for_resources(colors) {
  //   if(!colors) return [];
  //   return []
  //   const [{ fill: f1 }, { fill: f2 }] = [colors.accent_1, colors.accent_2];
  //   const [l1, c1, h1, a1, l2, c2, h2, a2] = [f1.l, f1.c, f1.h, f1.a, f2.l, f2.c, f2.h, f2.a].map(parseFloat);
    
  //   const total_resources_count = Array.from(data.grouped_resources)
  //     .flatMap(([_, resources]) => resources).length;
    
  //   const hues = plot_curved_distribution(h1, h2, total_resources_count, 1);
  //   const lightness = plot_curved_distribution(l1, l2, total_resources_count, 1);
  //   const chromas = plot_curved_distribution(c1, c2, total_resources_count, 1);
    
  //   // Create flat array of color pairs (fill and text)
  //   return Array.from(data.grouped_resources)
  //     .flatMap(([_, resources]) => resources)
  //     .map((_, i) => ({
  //       fill: {
  //         l: lightness[i],
  //         c: chromas[i],
  //         h: hues[i],
  //         a: (a1 + a2) / 2
  //       },
  //       text: {
  //         // Should we use body text color from accent colors?
  //         l: lightness[i] > 60 ? 0 : 100, // Dark text on light backgrounds, light text on dark backgrounds
  //         c: 0,
  //         h: hues[i],
  //         a: 1
  //       }
  //     }));
  // }

  // Do we already have a date util for that kind of thing?
  function get_offset_date(base_date, offset_days) {
      // Parse the input date string
      // NOTE: A "YYYY-MM-DD" string is interpreted as a UTC date already
      const date = new Date(base_date); 
      
      // Add/subtract the offset (in days)
      date.setUTCDate(date.getUTCDate() + offset_days);
      
      // Format back to YYYY-MM-DD (use UTC methods to match UTC date parsing)
      const year = date.getUTCFullYear();
      const month = String(date.getUTCMonth() + 1).padStart(2, '0'); // Months are 0-based
      const day = String(date.getUTCDate()).padStart(2, '0');
      
      return `${year}-${month}-${day}`;
  }

  // let resource_colors = $derived(get_colors_for_resources(site_settings.colors.site_colors));

</script>

<svelte:head>
  <title>{t('book_now')} — {site_settings.name}</title>
</svelte:head>

<SEO
  title={`${t('booking')} | ${site_settings.name}`}
  description={site_settings.description}
  image={Array.from(data.grouped_resources)?.[0]?.[1]?.[0]?.images?.[0]?.src}
  type='service'
  author={site_settings.name}
/>

<MainPageContent>
  <BlockGrid>
    {#if data.current_user}
      <header class='flex-row justify-center px py p-6 hide-lg-up'>
        <div class='flex-row flex-wrap gap-x g-4'>
          <a href="/book{page.url.search}" data-sveltekit-replacestate>
            <ButtonLabel variant='brand {page.url.hash !== '#bookings' ? 'tab-selected' : 'tab'}'>{t('book_now')}</ButtonLabel>
          </a>
          <a href="/book{page.url.search}#bookings" data-sveltekit-replacestate>
            <ButtonLabel variant='brand {page.url.hash === '#bookings' ? 'tab-selected' : 'tab'}'>{t('manage_bookings')}</ButtonLabel>
          </a>
        </div>
      </header>
    {/if}

            <main class='resource-list flex-column p-10 pbs {page.url.hash === '#bookings' ? 'show-lg-up' : ''}'>
        <h1 class='text-preamble leading-trim mbe m-4'>{t('offices_desks_and_more')}</h1>
        <h1 class='text-heading2 leading-trim mbe m-4'>{t('book_with_one_click')}</h1>

      {#each Array.from(data.grouped_resources) as [resource_type, resources], groupIndex}
        {#each resources as resource, resourceIndex}
          {@const color_index = Array.from(data.grouped_resources)
            .slice(0, groupIndex)
            .reduce((acc, [_, res]) => acc + res.length, 0) + resourceIndex}
          <div
            class='resource-item-wrapper flex-column gap-y g-2'
            >
            <!-- style:--resource-fill="oklch({resource_colors[color_index].fill.l}% {resource_colors[color_index].fill.c} {resource_colors[color_index].fill.h} / {resource_colors[color_index].fill.a})"
            style:--resource-text="oklch({resource_colors[color_index].text.l}% {resource_colors[color_index].text.c} {resource_colors[color_index].text.h} / {resource_colors[color_index].text.a})" -->
            {#if resourceIndex === 0}
              <div class='resource-type-heading flex-row justify-between'>
                <h3 class='text-preamble leading-trim'>
                  {resources.length === 1 ? t(resource_type) : t(resource_type + '_plural')}
                </h3>
                {#if resource_type === 'flex_desk' || resource_type === 'open_day' || resource_type === 'meeting_room'}
                  {#if resources.some(resource => data.bookings_count_by_resource?.[resource.entry_id] > 0)}
                    <p class='text-preamble leading-trim bookings-count-label'>{t('bookings')}:</p>
                  {/if}
                {:else if resource_type === 'office' || resource_type === 'fixed_desk' || resource_type === 'addon'}
                  {#if resources.some(resource => data.bookings_count_by_resource?.[resource.entry_id] > 0)}
                    <p class='text-preamble leading-trim bookings-count-label'>{t('subscriptions')}:</p>
                  {/if}
                {/if}
              </div>
            {/if}
            <a 
              href={`/book/${resource.slug}-${resource.entry_id}`} 
              class='resource-item-inner flex-row'
            >
              {#if resource.images?.[0]}
                <Image 
                  {...resource.images?.[0]} 
                  aspect_ratio='1/1' 
                  fit_to_frame={false} 
                  width={100} 
                  height={100}
                  sizes="100px"
                />
              {/if}
              <div class='flex-column px py p-4 justify-center gap-y g-4 '>
                {#if resource.preview_description}
                <div class='flex-row flex-wrap gap-x gap-y g-4 items-end'>
                  <h3 class='text-body leading-trim'>{resource.title}</h3>
                  <p class='text-preamble leading-trim'>{@html format_price_info(resource, t)}</p>
                </div>
                {:else}
                  <h3 class='text-body leading-trim'>{resource.title}</h3>
                  <p class='text-preamble leading-trim'>{@html format_price_info(resource, t)}</p>
                {/if}
                {#if resource.preview_description}
                  <p class='text-caption text-3 leading-trim truncate'>{resource.preview_description}</p>
                {/if}
              </div>

              {#if resource_type === 'flex_desk' || resource_type === 'open_day' || resource_type === 'meeting_room'}
                {#if data.bookings_count_by_resource?.[resource.entry_id] > 0}
                  <p class='bookings-count-badge text-preamble px py p-3 text-center'>
                    {#if data.bookings_count_by_resource?.[resource.entry_id] === 1}
                      {t('on_count_of_day', {count: data.bookings_count_by_resource?.[resource.entry_id]})}
                    {:else}
                      {t('on_count_of_days', {count: data.bookings_count_by_resource?.[resource.entry_id]})}
                    {/if}
                  </p>
                {/if}
              {:else if resource_type === 'office' || resource_type === 'fixed_desk' || resource_type === 'addon'}
                {#if data.bookings_count_by_resource?.[resource.entry_id] > 0}
                  <p class='bookings-count-badge text-preamble px py p-3'>{data.bookings_count_by_resource?.[resource.entry_id]}×</p>
                {/if}
              {/if}
            </a>
          </div>
        {/each}
      {/each}
      </main>

    {#if data.current_user}
      <aside class='flex-column pbs p-10 gap-y g-4 {page.url.hash !== '#bookings' ? 'show-lg-up' : ''}'>
        <h2 class='text-heading2 hide-lg-up leading-trim mbe m-4'>{t('bookings')}</h2>
        <div class='flex-column gap-y g-7'>
          <div class="flex-wrap items-center gap-x gap-y g-4">
            <label for='date-selector' class='text-preamble leading-trim nowrap'>{t('bookings_on')}</label>
            <!-- <p class='text-control leading-trim'>{t('bookings')}</p> -->
            <div class='flex-row border-1 border-round'>
              <a href="/book?date={get_offset_date(data.booking_overview_for_day.date, -1)}{page.url.hash || ''}" data-sveltekit-reset="false">
                <ButtonLabel variant='brand ghostly' start_icon='arrow-left' />
              </a>
              <input 
                id='date-selector'
                type="date" 
                class='text-control ghostly'
                value={data.booking_overview_for_day.date} 
                onchange={(event)=> {
                  goto(`/book?date=${event.target.value}${page.url.hash || ''}`);
                }}
              />
              <VerticalDivider />
              <a href="/book?date={today_date}{page.url.hash || ''}" data-sveltekit-reset="false">
                <ButtonLabel variant='brand ghostly'><span class={today_date !== data.booking_overview_for_day.date ? 'text-3' : ''}>{t('today')}</span></ButtonLabel>
              </a>
              <a href="/book?date={get_offset_date(data.booking_overview_for_day.date, 1)}{page.url.hash || ''}" data-sveltekit-reset="false">
                <ButtonLabel variant='brand ghostly' start_icon='arrow-right' />
              </a>
            </div>
          </div>
          <!-- Overview of half_hourly_bookings per resource -->         
          {#each Object.entries(data.booking_overview_for_day.half_hourly_bookings).sort((a, b) => a[1].resource_name.localeCompare(b[1].resource_name)) as [resource_id, resource]}
            <div class='flex-column gap-y g-3'>
              <a 
                href={`/book/${resource.resource_slug}-${resource_id}?year=${data.booking_overview_for_day.week_year}&week=${data.booking_overview_for_day.week}`}
                class='text-body -bold flex-row gap-x g-2 items-center'
              >
                {resource.resource_name}
                <Icon name='link' class='text-3' />
              </a>
              <ScrollIndicator direction='row' class='snap-x scrollbar-thin py p-3'>
                {#each resource.bookings as booking, i}
                  <div class='flex-column gap-x gap-y g-3 {i > 0 ? 'ps p-6' : ''}' style='min-width: max-content;'>
                    <div class='flex-row gap-x gap-y g-2'>
                      <!-- end_slot is the INCLUSIVE last 30-min slot, so the booking ends at end_slot + 1 -->
                      <p class='text-caption'>{get_formatted_time(booking.start_slot)}{booking.end_slot > booking.start_slot ? ` - ${get_formatted_time(booking.end_slot + 1)}` : ''}</p>
                      <p class='text-caption text-3'>({format_half_hourly_slot_duration(booking.start_slot, booking.end_slot)})</p>
                    </div>
                    <div class='flex-row gap-x g-3 items-center' title={booking.user_name}>
                      <Avatar avatar={booking.user_avatar} name={booking.user_name} />
                      <p class='text-body truncate-12'>{booking.user_name.split(' ')[0]} {booking.user_name.split(' ')?.[1] ? booking.user_name.split(' ')[1].slice(0, 1) + '.' : ''}</p>
                    </div>
                  </div>
                {/each}
              </ScrollIndicator>
            </div>
            <hr />
          {/each}

          <!-- Overview of daily_bookings per resource -->
          {#each Object.entries(data.booking_overview_for_day.daily_bookings) as [resource_id, resource]}
            <div class='flex-column gap-y g-3'>
              <a 
                href={`/book/${resource.resource_slug}-${resource_id}?year=${data.booking_overview_for_day.year}&month=${data.booking_overview_for_day.month}`} 
                class='text-body -bold flex-row gap-x g-2 items-center'
              >
                {resource.resource_name}
                <Icon name='link' class='text-3' />
              </a>
              <div class='flex-column gap-y g-3'>
                {#each resource.bookings as booking}
                  <div class='flex-row gap-x g-3 items-center'>
                    <p class='text-preamble'>{booking.booking_count}×</p>
                    <Avatar avatar={booking.user_avatar} name={booking.user_name} />
                    <p class='text-caption'>{booking.user_name}</p>
                  </div>
                {/each}
              </div>
            </div>
          {/each}

          {#if Object.keys(data.booking_overview_for_day.half_hourly_bookings).length === 0 && Object.keys(data.booking_overview_for_day.daily_bookings).length === 0}
          <Alert variant='brand' icon='box-crossed-out'>
              <p class='text-body'>{t('no_bookings_on_day', {date: booking_overview_for_day_date_formatted})}</p>
            </Alert>
          {/if}


        </div>
      </aside>
    {/if}

    <!-- TODO: Display marketing content for non-logged in users (in <aside>) -->

    <footer class='flex-column items-center px py p-4 gap-y g-5 mbs m-block-s'>
      <p class='text-center text-caption text-3'>{t('business_customer_vat_notice')}</p>
      {#if site_settings.terms_and_conditions_preview_ref}
        <p class='text-caption text-3 text-center'>
            {@html t('notice_terms_and_conditions', {
              terms_and_conditions: site_settings.terms_and_conditions_preview_ref
            })}
        </p>
      {/if}
    </footer>
  </BlockGrid>
</MainPageContent>

<style lang='postcss'>
  header, aside, main, footer {
    grid-column: var(--dynamic-island-track-start) / var(--dynamic-island-track-end);
  }
  @media (max-width: 1024px) {
    aside, main {
      padding-block-start: var(--size-4);
    }
  }
  @media (min-width: 1025px) {
    header {
      display: none;
    }
    main, footer {
      grid-column: var(--dynamic-island-track-start) / 24;
    }
    aside {
      grid-column: var(--center-gutter-track) / -1;
      padding-inline: var(--grid-gutter) var(--page-inline-spacing);
      background-color: var(--color-default-background);
      box-shadow: var(--shadow-md);
      grid-row: 1 / 3;
    }
    footer {
      grid-row: 2 / 3;
    }
  }
  @media (min-width: 1281px) {
    main, footer {
    }
  }
  .resource-list {
    --resource-item-wrapper-transform: 3px;
    --resource-item-radius: var(--radius-lg);
  }

  .resource-type-heading {
    margin-block-end: var(--size-4);
  }

  .resource-item-wrapper {

    &:not(:first-child) .resource-type-heading {
      margin-block-start: var(--size-10);
    }
    .resource-item-inner {
      background: var(--color-default-background-alpha-50);
      border-top: 1px solid var(--color-default-background);
      /* background: var(--resource-fill);
      color: var(--resource-text);
      * {
        --text-color: var(--resource-text);
      } */
      :global(.media-item) {
        border-top-right-radius: 0;
        border-bottom-right-radius: 0;
      }
    }
  }
  .resource-item-wrapper {
    transition: transform 0.2s ease;
    .resource-item-inner {
      transition: border-radius 0.2s ease, background-color 0.2s ease, color 0.2s ease;
    }
  }

  .resource-item-wrapper:has(.resource-type-heading),
  .resource-item-wrapper:first-of-type {
    .resource-item-inner {
      border-top-left-radius: var(--resource-item-radius);
      border-top-right-radius: var(--resource-item-radius);
    }
  }

  /* TODO: the below global selectors should not be needed, it's a Svelte Compiler bug */
  /* See: https://github.com/sveltejs/svelte/issues/14072 */
  .resource-list :global(.resource-item-wrapper:has( + .resource-item-wrapper .resource-type-heading)),
  .resource-item-wrapper:last-of-type {
    .resource-item-inner {
      border-bottom-left-radius: var(--resource-item-radius);
      border-bottom-right-radius: var(--resource-item-radius);
    }
  }
  @media (hover: hover) {
  
    /* Cards before the hovered card move up */
    .resource-list :global(.resource-item-wrapper:has(~ .resource-item-wrapper:hover)) {
      transform: translateY(calc(var(--resource-item-wrapper-transform) * -1));
    }
    /* The immediate previous card */
    .resource-list :global(.resource-item-wrapper:has(+ .resource-item-wrapper:hover) .resource-item-inner) {
      border-bottom-left-radius: var(--resource-item-radius);
      border-bottom-right-radius: var(--resource-item-radius);
    }
    
    /* Hovered card stays in place */
    .resource-item-wrapper:hover {
      z-index: 2;
      .resource-item-inner {
        border-radius: var(--resource-item-radius);
        background-color: var(--color-default-emphasis-background);
        color: var(--color-default-emphasis-foreground);
      }
    }
    /* Cards after the hovered card move down */
    .resource-item-wrapper:hover ~ * {
      transform: translateY(var(--resource-item-wrapper-transform));
    }
    .resource-item-wrapper:hover + .resource-item-wrapper .resource-item-inner {
      border-top-left-radius: var(--radius-lg);
      border-top-right-radius: var(--radius-lg);
    }
  }
  
  .bookings-count-label, .bookings-count-badge {
    margin-inline-end: calc(0.8 * var(--resource-item-radius));
  }
  
  .bookings-count-badge {
    border-radius: var(--radius-sm);
    margin-inline-start: auto;
    background-color: var(--color-default-background);
    align-self: center;
    @media (min-width: 769px) {
      align-self: flex-start;
      border-top-left-radius: 0;
      border-top-right-radius: 0;
    }
  }
</style>